<template>
    <div class="prevent-screen-overflow">
        <div class="player-wrapper">
            <div class="player-label-container">
                <div class="video-title-container">
                    <div class="title-label">
                        <span ref="titleLabel" :title="showTitle(leftLabel)">{{leftLabel}}</span>
                    </div>
                </div>
                <div
                    class="video-description-container"
                    :style="labelStyle">
                    <div class="description-label">
                        <span>{{rightLabel}}</span>
                    </div>
                </div>
            </div>
            <div class="aspect-ratio-box">
                <div class="aspect-ratio-box-inside">
                    <PlayerError :message="errorMessage" :show="error"/>
                    <Player v-if="showPlayer"/>
                    <LoadingSpinner v-else />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Player from './Player';
import PlayerError from '../../components/PlayerError';
import LoadingSpinner from '../../components/LoadingSpinner';
import { getRightLabel, getLeftLabel } from '../../helpers/streams';
import constants from '../../helpers/constants';
import helper from '../../helpers/helper';

export default {
    name: 'PlayerWrapper',
    components: {
        Player,
        PlayerError,
        LoadingSpinner
    },
    data() {
        return {
            showPlayer: false,
            error: false,
            errorMessage: constants.errorMessages.webSDKLoading
        }
    },
    watch: {
        webSDKLoaded() {
            this.showPlayer = true;
        },
        webSDKError() {
            this.error = true;
        },
        activePlayback () {
            document.title = this.leftLabel ? `Web Player - ${this.leftLabel}` : 'Web Player';
        }
    },
    methods: {
        showTitle(label) {
            const element = this.$refs.titleLabel;

            if(element && element.offsetWidth < element.scrollWidth){
                return label
            }

            return '';
        },
        getLabelBackgroundColor() {
            const alpha = 0.8;

            return this.activePlayback && this.activePlayback.type.match(/^(hd|pano)$/)
                ? `rgba(30, 30, 30, ${alpha})`
                : this.activePlayback && this.activePlayback.attributes.team
                    ? helper.getLabelBackgroundColor(this.activePlayback.attributes.team.color, alpha)
                    : `rgba(45, 180, 220, ${alpha})`
        }
    },
    computed: {
        ...mapGetters({
            activePlayback: 'main/activePlayback'
        }),
        ...mapState({
            webSDKLoaded: state => state.asyncLoading.webSDK.loaded,
            webSDKError: state => state.asyncLoading.webSDK.error
        }),
        rightLabel() {
            if (this.activePlayback) {
                return getRightLabel(this.activePlayback.type);
            }

            return '';
        },
        leftLabel() {
            if (this.activePlayback) {
                const { type, attributes } = this.activePlayback;

                return getLeftLabel(type, attributes, attributes.name);
            }

            return '';
        },
        labelStyle(){
            return {
                backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, 0.6) 4%, rgba(0, 0, 0, 0.2) 100%),
                linear-gradient(to bottom, ${this.getLabelBackgroundColor()}, ${this.getLabelBackgroundColor()})`
            }
        }
    }
};
</script>
